import { Component, OnInit, Input } from '@angular/core';
import { PostRepossession } from '../../model/staterequirements.model';

@Component({
  selector: 'app-state-requirement-postrepossession',
  templateUrl: './state-requirement-postrepossession.component.html',
  styleUrls: ['./state-requirement-postrepossession.component.css']
})
export class StateRequirementPostrepossessionComponent implements OnInit {
  public role: string;
  public showFlag: boolean = false;
  private _postRepossession: PostRepossession;
  public parClicked: any;
  public agentClicked: any;
  public get postRepossession(): PostRepossession {
    return this._postRepossession;
  }
  @Input()
  public set postRepossession(value: PostRepossession) {
    if (typeof value !== 'undefined' && value !== null) {
      this._postRepossession = value;
    }
    else {
      this._postRepossession = new PostRepossession();
    }
  }
  constructor() {
    this._postRepossession = new PostRepossession();
  }

  ngOnInit() {
    this.role = localStorage.getItem("Role");
    this.parClicked = localStorage.getItem("parClicked");
    this.agentClicked = localStorage.getItem("agentClicked");
    if (this.role === "PC PAR Vendor Relations" || this.role === "PC Client" && (this.agentClicked ==="false" && this.parClicked === "false")) {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.parClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.parClicked === "true") {
      this.showFlag = false;
    }
    else {
      this.showFlag = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/state-requirement-postrepossession/state-requirement-postrepossession.component.ts